
import React from "react";

const BlogAuthor: React.FC = () => {
  return (
    <div className="mt-16 pt-8 border-t border-joerg-200 dark:border-joerg-700">
      <div className="text-center sm:text-left">
        <h4 className="text-lg font-semibold text-joerg-900 dark:text-joerg-100">Autor: Jörg Hörmann</h4>
        <p className="text-joerg-600 dark:text-joerg-300">Finanz- & Executive Coach</p>
        <p className="text-joerg-600 dark:text-joerg-300 text-sm mt-1">Spezialist für Katalysator-Führung an der Schnittstelle von Mensch & System</p>
      </div>
    </div>
  );
};

export default BlogAuthor;
